import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { List, ChevronRight } from 'lucide-react';
interface Section {
  id: string;
  title: string;
}
const sections: Section[] = [{
  id: 'quick-answer',
  title: 'The Quick Answer'
}, {
  id: 'rec-vs-pro',
  title: 'Recreational vs Professional'
}, {
  id: 'cra-factors',
  title: 'CRA Determination'
}, {
  id: 'jackpots',
  title: 'Big Jackpot Wins'
}, {
  id: 'online',
  title: 'Online Casino Rules'
}, {
  id: 'us-comparison',
  title: 'Canada vs USA'
}, {
  id: 'records',
  title: 'Record Keeping'
}, {
  id: 'faq',
  title: 'FAQ'
}];
export function TableOfContents() {
  const [activeSection, setActiveSection] = useState('');
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, {
      rootMargin: '-20% 0px -35% 0px'
    });
    sections.forEach(({
      id
    }) => {
      const element = document.getElementById(id);
      if (element) observer.observe(element);
    });
    return () => observer.disconnect();
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <nav className="hidden lg:block sticky top-24 w-64 flex-shrink-0 self-start" data-id="element-189">
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-5" data-id="element-190">
        <div className="flex items-center gap-2 mb-4 text-slate-900 font-bold" data-id="element-191">
          <List className="w-5 h-5 text-purple-600" data-id="element-192" />
          <h3 data-id="element-193">Table of Contents</h3>
        </div>
        <ul className="space-y-1" data-id="element-194">
          {sections.map(section => <li key={section.id} data-id="element-195">
              <button onClick={() => scrollToSection(section.id)} className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-all duration-200 flex items-center justify-between group ${activeSection === section.id ? 'bg-purple-50 text-purple-700 font-medium' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-196">
                {section.title}
                {activeSection === section.id && <motion.div layoutId="activeIndicator" data-id="element-197">
                    <ChevronRight className="w-4 h-4" data-id="element-198" />
                  </motion.div>}
              </button>
            </li>)}
        </ul>
      </div>

      {/* Casino Promo Banner Placeholder */}
      <div className="mt-6 bg-gradient-to-br from-slate-900 to-purple-900 rounded-xl p-5 text-center text-white shadow-lg border border-purple-500/30" data-id="element-199">
        <p className="text-xs font-bold text-purple-300 uppercase tracking-wider mb-2" data-id="element-200">
          Top Rated
        </p>
        <h4 className="font-bold text-lg mb-3" data-id="element-201">Play Responsibly</h4>
        <p className="text-sm text-slate-300 mb-4" data-id="element-202">
          Enjoy the games for fun, not as a way to make money.
        </p>
        <div className="text-xs text-slate-500" data-id="element-203">19+ • T&Cs Apply</div>
      </div>
    </nav>;
}